import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useParams } from 'react-router-dom';
import Layout from './components/Layout';
import { HomePage } from './features/home/pages/HomePage';
import AdminPage from './features/admin/pages/AdminPage';
import LoginPage from './features/auth/pages/LoginPage';
import { AuthProvider } from './features/auth/contexts/AuthContext';
import { ProjectProvider } from './features/project/contexts/ProjectContext';
import { DownloadProgressProvider } from './contexts/DownloadProgressContext';
import { DownloadProgressIcon } from './components/DownloadProgressIcon';
import { FirmwareProgressIcon } from './components/FirmwareProgressIcon';
import ProtectedRoute from './components/ProtectedRoute';
import DeviceManagement from './features/device/components/DeviceManagement';
import MapView from './components/MapView';
import { AnalysisPage } from './features/analysis/pages/AnalysisPage';
import { Provider } from 'react-redux';
import configureStore from './redux/store';
import { Amplify } from '@aws-amplify/core';
import config from './config';
import ResetPasswordForm from './features/auth/pages/ResetPasswordForm';
import { useUserPermissionsAfterLogin } from './features/admin/hooks/useUserPermissionsAfterLogin';


Amplify.configure(config);
const store = configureStore();



const ProjectsPage = () => {
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [subtitle, setSubtitle] = useState('');
  const [isEditProject, setIsEditProject] = useState(false);
  const navigate = useNavigate();
  const { projectId, tab } = useParams();
  const showBackNavigation = !!projectId;
  const setShowBackNavigationNoop = () => {};
  return (
    <ProtectedRoute>
      <Layout
        subtitle={subtitle}
        showBackNavigation={showBackNavigation}
        setShowBackNavigation={setShowBackNavigationNoop}
        onCreateClick={() => {
          setIsEditProject(false);
          setShowCreateForm(true);
        }}
        onEditClick={() => {
          setShowCreateForm(true);
          setIsEditProject(true);
        }}
        onBack={() => {
          setSubtitle('');
          setShowCreateForm(false);
          navigate('/Projects', { replace: true });
        }}
      >
        <HomePage
          showCreateForm={showCreateForm}
          onCreateFormClose={() => setShowCreateForm(false)}
          setSubtitle={setSubtitle}
          setShowBackNavigation={setShowBackNavigationNoop}
          showBackNavigation={showBackNavigation}
          isEditProject={isEditProject}
          urlProjectId={projectId}
          urlTab={tab}
        />
      </Layout>
    </ProtectedRoute>
  );
};

const AppContent = () => {
  const { hasPermission } = useUserPermissionsAfterLogin();
  return (
    <div className="h-full bg-page-bg">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPasswordForm />} />
        <Route path="/Projects" element={<ProjectsPage />} />
        <Route path="/Projects/:projectId" element={<ProjectsPage />} />
        <Route path="/Projects/:projectId/:tab" element={<ProjectsPage />} />
        {hasPermission('manage_admins') && <Route path="/Admin" element={
          <ProtectedRoute>
            <AdminPage />
          </ProtectedRoute>
        } />}
      {hasPermission('view_analytics') && <Route path="/Analysis" element={
          <ProtectedRoute>
            <Layout>
              <AnalysisPage />
            </Layout>
          </ProtectedRoute>
        } />}
        {hasPermission('manage_devices') && <Route path="/Devices" element={
          <ProtectedRoute>
            <Layout>
              <DeviceManagement />
            </Layout>
          </ProtectedRoute>
        } />}
        <Route path="/Devices" element={
          <ProtectedRoute>
            <Layout>
              <DeviceManagement />
            </Layout>
          </ProtectedRoute>
        } />
        {hasPermission('view_map') && <Route path="/Map" element={
          <ProtectedRoute>
            <Layout>
              <MapView />
            </Layout>
          </ProtectedRoute>
        } />}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      <DownloadProgressIcon />
      <FirmwareProgressIcon />
    </div>
  );
};

const App = () => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <ProjectProvider>
          <DownloadProgressProvider>
            <Router>
              <AppContent />
            </Router>
          </DownloadProgressProvider>
        </ProjectProvider>
      </AuthProvider>
    </Provider>
  );
};

export default App; 